import ImageComponent from '../content-types/image';
import { removeFileExtension } from '../utils/fileUtils';
import { encodeAssetUrl } from '@/app/utils/stringUtils';

function DotImage({ node }) {
    const attrs = node?.attrs;

    if (!attrs?.src || !attrs?.data) {
        return null;
    }

    const getAltText = () => {
        if (attrs.data.alt) return attrs.data.alt;
        if (attrs.data.title) return removeFileExtension(attrs.data.title);
        return 'image';
    };

    return (
        <>
            <div className="relative my-12 h-auto w-full">
                <ImageComponent
                    paragraphSpacing={attrs.data.paragraphSpacing}
                    priority={!!attrs.data.imagePrimaryLoad}
                    alt={getAltText()}
                    width={attrs.data.width}
                    quality={attrs.data.quality}
                    height={attrs.data.height}
                    title={attrs.data.title}
                    positionCenter={attrs.data.positionCenter}
                    asset={encodeAssetUrl(attrs.src)}
                />
            </div>
        </>
    );
}

export default DotImage;
